const VERIFICATION_STEPS = {
  ADD_CONTENT: 'addContent',
  GET_VERIFICATION_CODE: 'getVerificationCode',
  VERIFICATION_CODE_SENT: 'verificationCodeSent',
  VERIFICATION_SUCCESS: 'verificationSuccess',
} as const;

const MODES = {
  PHONE: 'phone',
  EMAIL: 'email',
} as const;

export type MODES_VALUES = (typeof MODES)[keyof typeof MODES];

export { MODES, VERIFICATION_STEPS };
